<template>
	<div class="resource-stats">
		<div
			v-for="question in resource.questions"
			:key="question.question_id"
			class="margin-bottom-xs-2"
		>
			<p>
				<strong><span v-html="question.question"></span></strong>
			</p>
			<div class="table-responsive">
				<table class="table table-bordered">
					<thead>
						<tr>
							<th scope="col">Användare</th>
							<th scope="col">Datum</th>
							<th scope="col">Svar</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="answer in getUserAnswersByQuestionId(
								question.question_id
							)"
							:key="question.question_id + answer.user_email"
						>
							<td>{{ answer.user_email }}</td>
							<td>{{ answer.updated_at }}</td>
							<td>{{ answer.answer }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "ResourceStats",
	props: ["resource"],
	components: {},
	computed: {},
	methods: {
		getUserAnswersByQuestionId(questionId) {
			var users = this.$store.state.groupMeta.users;
			var answers = [];
			for (var i in users) {
				var user = users[i];
				var answerObject = {
					answer: "–",
					updated_at: "–",
					user_email: user.user_email
				};
				for (var x in user.answers) {
					if (user.answers[x].question_id == questionId) {
						answerObject.answer = user.answers[x].answer;
						answerObject.updated_at = user.answers[x].updated_at;
					}
				}
				answers.push(answerObject);
			}
			return answers;
		}
	},
	mounted() {}
};
</script>